import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const tariffmanagementRoute = {
  path: '/tariffmanagement',
  component: Layout,
  name: 'tariffmanagement',
  hidden: false,
  meta: {
    title: 'Tarifs',
    icon: 'mdi:tag-outline',
    permissions: [P.PRODUCTS.MANAGE],
  },
  children: [
    // Dashboard gestion tarifaire
    {
      path: '/tariffmanagement/tm_main',
      component: () => import('@/views/tariffmanagement/TmMain'),
      name: 'Dashboard de Gestion Tarifaire',
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: {
        title: 'Grilles tarifaires',
        icon: 'mdi:tag-outline',
        permissions: [P.PRODUCTS.MANAGE],
      },
      hidden: false,
    },
    // Ajouter une grille de produit
    {
      path: '/tariffmanagement/grid/add',
      component: () => import('@/views/tariffmanagement/AddGrid'),
      name: 'Créer une grille',
      meta: {
        title: 'Créer une grille',
        icon: 'mdi:table-plus',
        noCache: true,
        permissions: [P.PRODUCTS.MANAGE],
      },
      // Action, pas destination : le bouton de l'écran des grilles y mène.
      hidden: true,
    },
    // Voir/éditer une grille
    {
      path: '/tariffmanagement/grid/:id(\\d+)',
      component: () => import('@/views/tariffmanagement/EditGrid'),
      name: 'Éditer une grille',
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: {
        title: 'Éditer une grille',
        permissions: [P.PRODUCTS.MANAGE],
      },
      hidden: true,
    },
    // Dupliquer une grille
    {
      path: '/tariffmanagement/grid/duplicator',
      component: () => import('@/views/tariffmanagement/Duplicator'),
      name: 'GridDuplicator',
      // `noCache` maintenu : l'ecran recoit la grille source par `params` sur un chemin
      // qui n'en declare aucun, que vue-router 4 jette — il ne s'affiche donc plus, cache
      // ou non. Le mettre sous <keep-alive> y ajouterait un melange entre deux grilles :
      // sa cle d'instance est constante, `data()` resterait fige sur la premiere.
      meta: {
        title: 'Dupliquer une grille',
        noCache: true,
        permissions: [P.PRODUCTS.MANAGE],
      },
      hidden: true,
    },
    // Configurer un forfait mobile : son enveloppe et son contenu
    {
      path: '/tariffmanagement/phone_plan/:id(\\d+)',
      component: () => import('@/views/tariffmanagement/EditPhonePlan'),
      name: 'EditPhonePlan',
      // `noCache` : l'ecran charge son forfait dans `onMounted` d'apres
      // `:id`. Sous <keep-alive>, l'instance est reutilisee d'un forfait a
      // l'autre et `onMounted` ne retire pas — on resterait sur le precedent.
      meta: {
        title: 'Configurer un forfait',
        noCache: true,
        permissions: [P.PRODUCTS.MANAGE],
      },
      hidden: true,
    },
    // Gérer un compte (phone line)
    {
      path: '/tariffmanagement/phone_line/:id(\\d+)',
      component: () => import('@/views/tariffmanagement/EditPhoneLine'),
      name: 'EditPhoneline',
      meta: {
        title: 'Gérer un compte',
        noCache: true,
        permissions: [P.PRODUCTS.MANAGE],
      },
      hidden: true,
    },
  ],
}

export default tariffmanagementRoute
